/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Defaultpausereasonid3Inputs */

const en_entity_defaultpausereasonid3 = /** @type {(inputs: Entity_Defaultpausereasonid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default Pause Reason ID`)
};

const de_entity_defaultpausereasonid3 = /** @type {(inputs: Entity_Defaultpausereasonid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Pausengrund-ID`)
};

/**
* | output |
* | --- |
* | "Default Pause Reason ID" |
*
* @param {Entity_Defaultpausereasonid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_defaultpausereasonid3 = /** @type {((inputs?: Entity_Defaultpausereasonid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Defaultpausereasonid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_defaultpausereasonid3(inputs)
	return de_entity_defaultpausereasonid3(inputs)
});
export { entity_defaultpausereasonid3 as "entity_defaultPauseReasonId" }